(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[276],{

/***/ 1550:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/highlights",
      function () {
        return __webpack_require__(9540);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _YouTubePlaylist__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _YouTubePlaylist__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3602);



/***/ }),

/***/ 9540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ HighlightsPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _storyblok_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9036);
/* harmony import */ var _components_YouTubePlaylist__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7693);




var HighlightsPageHead = function(param) {
    var seo = param.seo, isProd = param.isProd;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            !isProd && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: seo === null || seo === void 0 ? void 0 : seo.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "initial-scale=1.0, width=device-width, maximum-scale=1.0, user-scalable=0"
            }, "viewport"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: seo === null || seo === void 0 ? void 0 : seo.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: seo === null || seo === void 0 ? void 0 : seo.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: seo === null || seo === void 0 ? void 0 : seo.og_title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: seo === null || seo === void 0 ? void 0 : seo.og_description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "/images/next_tournament_s3.jpg"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:title",
                content: seo === null || seo === void 0 ? void 0 : seo.twitter_title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:description",
                content: seo === null || seo === void 0 ? void 0 : seo.twitter_description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:image",
                content: "/images/next_tournament_s3.jpg"
            })
        ]
    });
};
var __N_SSG = true;
function HighlightsPage(param) {
    var isProd = param.isProd, story = param.story, videos = param.videos, videosTemplate = param.videosTemplate, nextPageToken = param.nextPageToken, playlistId = param.playlistId;
    var ref, ref1, ref2;
    story = (0,_storyblok_react__WEBPACK_IMPORTED_MODULE_2__/* .useStoryblokState */ .f0)(story);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HighlightsPageHead, {
                seo: story === null || story === void 0 ? void 0 : (ref = story.content) === null || ref === void 0 ? void 0 : ref.seo,
                isProd: isProd
            }),
            story === null || story === void 0 ? void 0 : (ref1 = story.content) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.body) === null || ref2 === void 0 ? void 0 : ref2.map(function(c) {
                if (c.component === "youtube_playlist" && videos && videos.length > 0) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_YouTubePlaylist__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        videos: videos,
                        videosTemplate: videosTemplate,
                        nextPageToken: nextPageToken,
                        playlistId: playlistId
                    }, c._uid);
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storyblok_react__WEBPACK_IMPORTED_MODULE_2__/* .StoryblokComponent */ .Xj, {
                    blok: c
                }, c._uid);
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(1550); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);